module.exports = __webpack_public_path__ + "static/media/sheeren.07d8fc44.png";